import React, { useMemo } from 'react'
import DataTable from '../../../../ui/DataTable/DataTable'
import Spinner from '../../../../ui/Spinner/Spinner'
import Button from '../../../../ui/Button/Button'
import EmptyData from '../../../../ui/EmptyData/EmptyData'
import { formatSmsAuthorName } from '../../../../config/smsAccessControl'
import {
  SMS_DELIVERY_LABELS,
  SMS_SOURCE_LABELS,
  SMS_SUBMISSION_LABELS,
  formatSmsLabel,
  formatSmsTimestamp,
} from './smsUiUtils'

function SmsTable({ rows, isLoading, onOpenDetail, onLoadMore, nextCursor, isLoadingMore }) {
  const columns = useMemo(
    () => [
      {
        field: 'createdAt',
        headerName: 'Дата',
        width: 170,
        renderCell: (params) => formatSmsTimestamp(params.row.createdAt),
      },
      {
        field: 'source',
        headerName: 'Тип повідомлення',
        width: 150,
        renderCell: (params) => formatSmsLabel(SMS_SOURCE_LABELS, params.row.source),
      },
      {
        field: 'maskedRecipient',
        headerName: 'Номер',
        width: 150,
      },
      {
        field: 'sender',
        headerName: 'Відправник',
        width: 120,
        renderCell: (params) => params.row.sender || '—',
      },
      {
        field: 'createdBy',
        headerName: 'Автор',
        width: 160,
        renderCell: (params) =>
          formatSmsAuthorName(params.row.createdBy, params.row.createdByLabel),
      },
      {
        field: 'submissionStatus',
        headerName: 'Статус відправки',
        width: 150,
        renderCell: (params) => formatSmsLabel(SMS_SUBMISSION_LABELS, params.row.submissionStatus),
      },
      {
        field: 'deliveryStatus',
        headerName: 'Статус доставки',
        width: 140,
        renderCell: (params) => formatSmsLabel(SMS_DELIVERY_LABELS, params.row.deliveryStatus),
      },
      {
        field: 'providerMessageId',
        headerName: 'ID у TurboSMS',
        minWidth: 160,
        flex: 1,
        renderCell: (params) => params.row.providerMessageId || '—',
      },
      {
        field: 'normalizedError',
        headerName: 'Помилка',
        minWidth: 180,
        flex: 1,
        renderCell: (params) => params.row.normalizedError || params.row.errorCode || '—',
      },
      {
        field: 'actions',
        headerName: '',
        width: 64,
        sortable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => (
          <div className="SmsTable-Action" onClick={(event) => event.stopPropagation()}>
            <Button
              theme="circle"
              fill="white"
              icon="eye"
              className="SmsTable-DetailButton"
              tooltip="Деталі"
              onClick={() => onOpenDetail(params.row.id)}
            />
          </div>
        ),
      },
    ],
    [onOpenDetail]
  )

  if (isLoading && !rows.length) {
    return (
      <div className="SmsTable-State">
        <Spinner type="module" />
      </div>
    )
  }

  if (!rows.length) {
    return (
      <div className="SmsTable-State">
        <EmptyData title="Поки немає відправлених SMS" />
      </div>
    )
  }

  return (
    <div className="SmsTable">
      <DataTable
        table={{
          rows,
          columns,
          disableSelectionOnClick: true,
          onRowDoubleClick: (params) => onOpenDetail(params.row.id),
        }}
      />
      {nextCursor ? (
        <div className="SmsTable-More">
          <Button
            title="Показати ще"
            theme="solid"
            fill="accent"
            size={32}
            onClick={onLoadMore}
            isLoading={isLoadingMore}
          />
        </div>
      ) : null}
    </div>
  )
}

export default SmsTable
